"use strict";

import dispatcher from "./../dispatcher";
import {Collection} from "vwa/flux";
import poiStore from "./pois";

const openedDetailsStore = new Collection({keyNames: ["id"]});
export default openedDetailsStore;

window.openedDetailsStore = openedDetailsStore;

const DEFAULT_SIZE = 4;
const DEFAULT_VEHICLE_TAB = "activity";
const DEFAULT_POI_TAB = "properties";

function getDefaultTab(type) {
	if (type == "VehicleDetails") return DEFAULT_VEHICLE_TAB;
	else if (type == "POIDetails") return DEFAULT_POI_TAB;
	else return null;
}

dispatcher.on('openDetails', (type, id, pageId, size) => {
	openedDetailsStore.insert([
		{
			type:		type,
			id:			id,
			activePage:	pageId || getDefaultTab(type),
			size:		size || DEFAULT_SIZE
		}
	]);
});

dispatcher.on('closeDetails', (type, id) => {
	openedDetailsStore.remove([id]);
});

dispatcher.on('switchDetailsPage', (id, pageId) => {
	
	const details = openedDetailsStore.get(id);
	if (!pageId || !id) return;
	
	openedDetailsStore.update(id, {
		type:		details.type,
		id:			id,
		activePage:	pageId,
		size:		details.size
	});
});

dispatcher.on("resizeDetails", (id, size) => {
	
	const details = openedDetailsStore.get(id);
	if (size === undefined || !id) return;
	
	openedDetailsStore.update(id, {
		type:		details.type,
		id:			id,
		activePage:	details.activePage,
		size:		size
	});
});

dispatcher.on("logout", () => {
	openedDetailsStore.set(null);
});

poiStore.on("remove", pois => {
	openedDetailsStore.remove(pois.map(p => p._id));
});


// WEBPACK FOOTER //
// ./src/store/openedDetails.js